
import { defineComponent } from 'vue';
import LoaderLabel from '@/components/ui/LoaderLabel.vue';

export default defineComponent({
  name: "AppLoader",
  components: {LoaderLabel},
  props: {
    label: {
      type: String,
      default: 'general.loading'
    },
  }
})
